@use "@styles/variables";
@use "@styles/mixins";

.filters {
    display: flex;
    align-items: center;
    gap: variables.rem(12px);
}

.table {
    font-size: variables.rem(14px);

    tbody tr {
        cursor: pointer;

        td {
            padding: variables.rem(14px 8px 13px);
            height: variables.rem(63px);
        }

        td:first-child {
            padding-left: variables.rem(24px);
        }

        &:hover {
            td:not(.empty) {
                background-color: variables.$misc-alpha-50;
                cursor: pointer;
            }

            .category-select-prompt:not(.category-select-prompt--readonly) {
                border-color: variables.$misc-alpha-200;
            }
        }
    }

    tfoot {
        white-space: nowrap;
        font-size: variables.rem(12px);
        color: variables.$gray-700;
        cursor: auto;
    }

    .footerRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
}

.empty {
    cursor: default;
}

.narrow {
    width: 0;
    text-align: center;
}

.date-column {
    width: variables.rem(110px);
}

.date {
    white-space: nowrap;
    font-size: variables.rem(12px);
    color: variables.$gray-700;
}

.document-name {
    display: inline-flex;
    align-items: center;
    gap: variables.rem(8px);
    word-break: break-word;

    svg {
        flex-shrink: 0;
    }
}

.status {
    text-align: center;
    color: variables.$gray-500;
}

.entity {
    text-align: center;

    & > span {
        display: inline-flex;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
}

.actions-column {
    width: variables.rem(80px);
}

.actions > * {
    opacity: 0;
}

.row:hover,
.dropdown-open {
    .actions > * {
        opacity: 1;
    }
}

.placeholder-row {
    :where(:not(.placeholder-status)) svg {
        @include mixins.grayed-out-icon();
    }

    > *:not(.placeholder-status) {
        color: variables.$gray-500;
    }
}

.upload-cta,
.icon {
    background-color: variables.$blue-600;
    color: variables.$white;
}

.upload-cta {
    border-radius: variables.$border-radius-lg;
    padding: variables.rem(18px 24px);
}

.icon {
    border-radius: 999em;
    display: flex;
    align-items: center;
    justify-content: center;

    width: variables.rem(54px);
    aspect-ratio: auto 1;

    @include mixins.svg-color(currentColor);
}

.upload-state {
    display: flex;
    align-items: center;
    gap: variables.rem(4px);
    font-size: variables.rem(10px);
    color: variables.$gray-700;

    svg {
        @include mixins.svg-color(variables.$gray-900);
    }
}

.entityDropdown {
    width: 220px;
}
